<template>
  <div>
    <div class="actions">
      <div class="tag">
        <el-tag v-if="hasQueryTag" closable @close="clearQueryTag">{{
          queryTag
        }}</el-tag>
      </div>
      <el-button
        class="main-button"
        size="small"
        @click="$router.push({ name: 'admin_repos_draft' })"
        >草稿</el-button
      >
      <el-button
        class="main-button"
        type="primary"
        size="small"
        @click="createRepo"
        >创建资料</el-button
      >
    </div>
    <div class="mt-10">
      <ReposListAdminTable
        showPublishedAt
        :repos="repos"
        @delete="deleteRepo"
      ></ReposListAdminTable>
    </div>
    <div class="paging">
      <el-pagination
        @current-change="handlePaginatorPageChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="paging.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { OopsErrorELMessage, ReposMixin } from "@/mixins";
import ReposListAdminTable from "@/components/ReposListAdminTable";
export default {
  name: "Repos",
  mixins: [OopsErrorELMessage, ReposMixin],
  components: {
    ReposListAdminTable
  },
  created() {
    this.listRepos();
  },
  methods: {
    createRepo() {
      this.$http
        .post("/api/v1/repos", {})
        .then(resp => {
          this.$router.push({
            name: "admin_repo_edit",
            params: { repo_id: resp.data.id }
          });
        })
        .catch(() => this.oopsError());
    }
  }
};
</script>
